import React, { useState } from 'react';
import { MessageSquare, Users, Search, X } from 'lucide-react';
import ContactList from './ContactList';
import ChatInterface from './ChatInterface';

const ChatLayout = () => {
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [showContactList, setShowContactList] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const handleContactSelect = (contactId) => {
    setSelectedContactId(contactId);
    // On mobile, hide contact list when chat is selected
    if (window.innerWidth < 768) {
      setShowContactList(false);
    }
  };

  const handleBackToList = () => {
    setShowContactList(true);
    setSelectedContactId(null);
  };

  return (
    <div className="flex h-[calc(100vh-4rem)] bg-gray-50">
      {/* Contact List Sidebar */}
      <div className={`${showContactList ? 'flex' : 'hidden'} md:flex flex-col w-full md:w-1/3 lg:w-1/4 border-r border-gray-200 bg-white`}>
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-200 bg-white">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-primary-600" />
              Messages
            </h2>
          </div>
          
          {/* Search */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search contacts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm"
            />
          </div>
        </div>

        {/* Contact List */}
        <div className="flex-1 overflow-y-auto">
          <ContactList
            searchTerm={searchTerm}
            selectedContactId={selectedContactId}
            onContactSelect={handleContactSelect}
          />
        </div>
      </div>

      {/* Chat Interface */}
      <div className={`${!showContactList ? 'flex' : 'hidden'} md:flex flex-col flex-1 bg-gray-50`}>
        {selectedContactId ? (
          <ChatInterface
            contactId={selectedContactId}
            onBack={handleBackToList}
          />
        ) : (
          <div className="flex-1 flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <MessageSquare className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500 text-lg">Select a contact to start chatting</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatLayout;

